import { spacing } from "./spacing";

/** Responsive breakpoints aligned with MUI defaults */
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

/** Max content widths per breakpoint */
export const container = {
  sm: 600,
  md: 960,
  lg: 1120,
  xl: 1280,
} as const;

export const grid = {
  columns: 12,
  gutter: spacing[16],
  columnGap: spacing[16],
} as const;

export const pageMargin = {
  xs: spacing[16],
  sm: spacing[20],
  md: spacing[24],
  lg: spacing[32],
} as const;

export type TBreakpoints = typeof breakpoints;
export type TContainer = typeof container;
export type TGrid = typeof grid;
export type TPageMargin = typeof pageMargin;
